// @module Digi.Marketing.Marketing
define('Digi.Marketing.Marketing.View'
,	[
		'digi_marketing_marketing.tpl'
	,	'Backbone'
	,   'Utils'
	,	'Profile.Model'
	,	'Digi.Marketing.Marketing.SS2Model'
    ]
, function (
		digi_marketing_marketing_tpl
	,	Backbone
	,   Utils
	,   ProfileModel
	,	DigiMarketingSS2Model
)
{
    'use strict';

	// @class Digi.Marketing.Marketing.View @extends Backbone.View
	return Backbone.View.extend({

		template: digi_marketing_marketing_tpl

	,	initialize: function (options) {

		var self = this;

		this.contactInfo = new DigiMarketingSS2Model();
		self.isLoading = true;

		this.contactInfo.fetch().done(function(result) {
			self.isLoading = false;
			self.render();
		});
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Digi.Marketing.Marketing.View.Context
	,	getContext: function getContext()
		{
			var environment = this.options.application.getComponent('Environment');
			var config = environment.getConfig('digiConfigSettings');
			var templateCode = config && config.MarketingHub && config.MarketingHub.code;
			templateCode = templateCode ? templateCode : '';

			var profile_model = ProfileModel.getInstance();
			this.userEmail = profile_model.attributes.email;
			this.companyName = profile_model.attributes.companyname;
			this.companyId = profile_model.attributes.internalid;

			if (this.contactInfo && this.contactInfo.get('isContact')) {
				this.contactId = this.contactInfo.get('internalid');
				this.firstName = this.contactInfo.get('firstName');
				this.lastName = this.contactInfo.get('lastName');
			}

			//@class Digi.Marketing.Marketing.View.Context
			this.templateCode = this.templateCode || templateCode
			return {
				templateCode: this.templateCode,
				userEmail: this.userEmail,
				companyName: this.companyName,
				companyId: this.companyId,
				contactId: this.contactId,
				firstName: this.firstName,
				lastName: this.lastName,
				isLoading: this.isLoading
			};
		}

		, getSelectedMenu: function getSelectedMenu() {
			return 'partnerportal'
		}

        , getBreadcrumbPages: function () {
            return [{
                text: Utils.translate('Marketing Hub'),
                href: '/marketingHub'
            }]
        }

	});
});
